export enum Errors {
  // Errors:
  INVALID_AUTHENTICATION,
  INVALID_CREDENTIALS,
  INVALID_PASSWORD_RESET_TOKEN,
  EXPIRED_PASSWORD_RESET_TOKEN,
  INVALID_REDIRECT_URL,
  WRONG_AUTH_LEVEL,
  INSUFFICIENT_AUTH_LEVEL,
  NOT_LOGGED_IN,
  CANNOT_CREATE_ACCOUNT_SITE_IDENTITY_EXISTS,
  CANNOT_CREATE_ACCOUNT_LOGIN_ID_EXISTS,
  LOGIN_ID_DOES_NOT_EXIST,
  SITE_ID_DOES_NOT_EXIST,
  SITE_ID_ALREADY_EXISTS,
  ACCOUNT_DOES_NOT_EXIST,
  IDENTITY_DOES_NOT_EXIST,
  NOT_IMPLEMENTED,
  UNKNOWN_ERROR,
  UNKNOWN_PASSWORD_ERROR,
  INVALID_PARAMETERS,
  INVALID_SITE,
  INVALID_ORIGIN,
  INVALID_EMAIL,
  INVALID_COUNTRY,
  NO_EMAIL,
  WRONG_OLD_PASSWORD,
  SAML_IDP_ENTITY_ID_DOES_NOT_EXIST,
  SAML_IDP_ENTITY_ID_ALREADY_EXISTS,
  SAML_IDP_EMAIL_DOMAIN_ALREADY_EXISTS,
  PASSWORD_MISMATCH,
  CANNOT_BECAUSE_IS_MANAGED_BY_SAML,
  UNABLE_TO_PARSE_SAML_RESPONSE,
  SAML_ATTRIBUTES_MISSING,

  // Triggers:
  TRIGGER_PASSWORD_CHANGE,
  TRIGGER_IDENTITY_VERIFICATION,
  INVALID_CAPTCHA,
  CANNOT_CREATE_CUSTOMER,
}

const statusCode = {
  [Errors.INVALID_AUTHENTICATION]: 403,
  [Errors.WRONG_AUTH_LEVEL]: 401,
  [Errors.INSUFFICIENT_AUTH_LEVEL]: 401,
  [Errors.NOT_LOGGED_IN]: 403,
  [Errors.INVALID_SITE]: 403,
};

/**
 * Used to throw user-facing errors.
 */
export class UserFacingError extends Error {
  public error: Errors;
  public errorMessage: string;
  public errorDetails: AnyObject;
  public statusCode: number;

  constructor(error: Errors, errorDetails?: AnyObject) {
    super(Errors[error]);
    this.error = error;
    this.errorMessage = Errors[error];
    this.errorDetails = errorDetails || {};
    this.statusCode = statusCode[error] || 400;
  }
}

/**
 * Action required error indicates further action is required.
 *
 * This is a user error (gets returned to the user) that requires error details to specify the action and does not get logged in error log.
 */
export class ActionRequiredError extends UserFacingError {
  constructor(error: Errors, errorDetails: AnyObject) {
    super(error, errorDetails);
    this.statusCode = 403;
  }
}
